import { css } from "@emotion/css";
import { space } from "@octopusdeploy/design-system-tokens";
import React from "react";
import { ManifestNavigationTreeLoadingSkeleton } from "~/areas/tasks/components/Task/Kubernetes/Manifests/ManifestNavigationTreeLoadingSkeleton";
import { ManifestViewerListLoadingSkeleton } from "~/areas/tasks/components/Task/Kubernetes/Manifests/ManifestViewerListLoadingSkeleton";
const manifestStyles = {
    container: css({
        display: "flex",
        flexDirection: "row",
        padding: space[16],
        paddingTop: 0,
        gap: space[16],
    }),
    manifestsContainer: css({
        flexGrow: 1,
    }),
};
export const KubernetesAppliedManifestsLoadingSkeleton = () => (<div className={manifestStyles.container}>
        <div>
            <ManifestNavigationTreeLoadingSkeleton />
        </div>
        <div className={manifestStyles.manifestsContainer}>
            <ManifestViewerListLoadingSkeleton />
        </div>
    </div>);
